import { render } from "./VentaView.vue?vue&type=template&id=51cd7963&scoped=true"
import script from "./VentaView.vue?vue&type=script&lang=js"
export * from "./VentaView.vue?vue&type=script&lang=js"

import "./VentaView.vue?vue&type=style&index=0&id=51cd7963&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51cd7963"]])

export default __exports__